@if (
  ['select'].includes(type()) ||
  options()?.length >= 1 ||
  options()[0]?.children?.length >= 1
) {
  <div
    class="w-auto h-auto flex items-center mobi-ui-padding-b-md max-w-auto -m-[8px]"
    [class.im-blue]="filter()['#name'] === 'field_cm_tax_segment'"
    [class.md:justify-center]="centerFilters()"
    [class]="{
      'flex-wrap': !scrollable() || !breakpoint.xsMax(),
      'overflow-x-auto': scrollable() && breakpoint.xsMax(),
      'no-scrollbar': scrollable() && breakpoint.xsMax(),
    }"
  >
    @if (isGrouped()) {
      <div class="p-[8px]">
        <span class="w-0 h-0 tag-control"></span>
        <button
          class="mobi-ui-btn-major mobi-ui-font-size-100 text-contrast bg-signature !min-h-[40px] !h-[40px] !border-none"
          (click)="open.set(!open())"
          [class.mobi-ui-ink-default]="open()"
        >
          <span [class.hidden]="open()">
            {{
              'show_filter' | texts: { context: 'frontend', default: 'Filter einblenden' }
            }}
          </span>
          <span [class.hidden]="!open()">
            {{
              'hide_filter' | texts: { context: 'frontend', default: 'Filter ausblenden' }
            }}
          </span>
          @if (!open()) {
            @let count = activeFilters()[filter()['#name']]?.length;
            @if (count) {
              <span
                class="w-[20px] aspect-1 flex items-center justify-center rounded-full bg-white text-signature-text mx-[2px] mobi-ui-font-size-50 flex-shrink-0"
              >
                {{ count }}
              </span>
            }
            <mobi-ui-icon-major name="switchboard" />
          } @else {
            <mobi-ui-icon-major name="the_x" />
          }
        </button>
      </div>
    }
    @if (!isGrouped() || open()) {
      @for (option of options(); track option.key || $index) {
        @if (option.value | hasResult) {
          @if (
            (option.key !== 'All' && type() === 'radios') ||
            ['checkboxes', 'select'].includes(type())
          ) {
            <div class="p-[8px]">
              @if (['checkboxes', 'select'].includes(type())) {
                <input
                  type="checkbox"
                  class="sr-only tag-control"
                  [class.is-active]="childrenSelected(option?.children ?? [])"
                  [value]="option.key"
                  [checked]="isChecked(option.key)"
                  (change)="onSelectionChange(option.key)"
                  [name]="filter()['#name']"
                  [id]="filter()['#name'] + option.key"
                />
              }
              @if (type() === 'radios') {
                <input
                  class="absolute h-0 w-0 opacity-0 tag-control"
                  type="radio"
                  [value]="option.key"
                  [checked]="isChecked(option.key)"
                  (change)="onFilterChange(option.key, true)"
                  [name]="filter()['#name']"
                  [id]="filter()['#name'] + option.key"
                />
              }
              <!-- Leaf options have no children. Test that case explicitly because
              Angular 22 evaluates the optional-chain expression as undefined. -->
              @if (!option.children?.length || option.children.length <= 1) {
                <ng-container
                  [ngTemplateOutlet]="label"
                  [ngTemplateOutletContext]="{ option: option }"
                ></ng-container>
              }

              @if (option.children && option.children.length > 1) {
                <button
                  type="button"
                  class="tag whitespace-nowrap !pr-[8px] flex items-center"
                  [mobiUiPopover]="popover"
                >
                  <span class="tag-text mobi-ui-text-truncate">
                    {{ selectedText(option.children) || (option.value | removeCount) }}
                  </span>
                  @let count = filterCount(option.children);
                  @if (count) {
                    <span
                      class="w-[20px] aspect-1 flex items-center justify-center rounded-full bg-white text-signature-text ml-[8px] mobi-ui-font-size-50 flex-shrink-0"
                    >
                      {{ count }}
                    </span>
                  }
                  <mobi-ui-icon-major name="down" class="!pr-[8px]" />
                </button>
                <ng-template #popover>
                  <mobi-ui-popover-major class="tag-popover mobi-ui-ink-blue">
                    @if (
                      ['checkboxes', 'select'].includes(type()) &&
                      option.children?.length > 1
                    ) {
                      <div
                        class="flex items-center mb-3 mobi-ui-font-size-100 mobi-ui-font-light"
                      >
                        <button
                          (click)="all(option?.children ?? [])"
                          class="mr-[10px] text-signature hover:text-black transition-colors"
                        >
                          {{
                            'select_all'
                              | texts: { context: 'frontend', default: 'Alle auswählen' }
                          }}
                        </button>
                        <button
                          (click)="all(option?.children ?? [], true)"
                          class="mr-[10px] text-signature hover:text-black transition-colors"
                        >
                          {{
                            'reset'
                              | texts: { context: 'frontend', default: 'Zurücksetzen' }
                          }}
                        </button>
                      </div>
                    }
                    @for (child of option.children; track child.key || $index) {
                      @if ((child.value | hasResult) && !child.hidden) {
                        <div class="py-[6px] flex items-center">
                          <input
                            class="popover-checkbox"
                            type="checkbox"
                            [value]="child.key"
                            [checked]="isChecked(child.key)"
                            (change)="onSelectionChange(child.key)"
                            [name]="filter()['#name']"
                            [id]="filter()['#name'] + child.key"
                          />
                          <label
                            class="mobi-ui-font-size-100 mobi-ui-font-regular mobi-ui-font-realist not-italic pl-[10px] flex-1"
                            [for]="filter()['#name'] + child.key"
                            [attr.data-text]="child.value | removeCount"
                          >
                            {{ child.value | removeCount }}
                          </label>
                        </div>
                      }
                    }
                  </mobi-ui-popover-major>
                </ng-template>
              }
            </div>
          }
        }
      }
    }
  </div>
}

<ng-template #label let-option="option">
  <label
    [class.mobi-ui-ink-default]="isDefaultStyle(option.key)"
    class="tag whitespace-nowrap"
    [for]="filter()['#name'] + option.key"
    [attr.data-text]="option.value | removeCount"
  >
    <span>{{ option.value | removeCount }}</span>
  </label>
</ng-template>
